<template>
  <div class="tx-ktgdealersearch module-filter-bar" :class="{ '-loading': !initialized, '-open': showFilters }">
    <div class="filter-bar__button" ref="link" @click="showFilters = !showFilters">
      <span>{{ $t('filterBar.button') }}</span>
    </div>
    <div class="filter-bar__filters" ref="container" v-if="!mobile || (mobile && showFilters)">
      <div class="filter-bar__header" v-if="mobile">
        <div class="header__title">
          <span>{{ $t('filterBar.button') }}</span>
        </div>
        <div class="header__close" @click="showFilters = false"></div>
      </div>
      <Filter
        identifier="division"
        :label="$t('filterBar.filters.vehicleTypes')"
        :option-groups="[{ title: '', options: vehicleTypes }]"
        :show-options="initialized && showOptions === 'vehicleTypes'"
        v-model="divisions"
        @open-options="showOptions = 'vehicleTypes'"
        @close-options="showOptions = ''"
        v-if="!['8200', '8300'].includes(brand) && !fixedModel && vehicleTypes.length" />
      <Filter
          identifier="model"
          :label="$t('filterBar.filters.models')"
          :option-groups="models"
          :show-options="initialized && showOptions === 'models'"
          v-model="selectedModels"
          @open-options="showOptions = 'models'"
          @close-options="showOptions = ''"
          v-if="!['8200', '8300'].includes(brand) && !fixedModel && models.length"/>
      <Filter
          identifier="model"
          :label="$t('filterBar.filters.layouts')"
          :option-groups="[{ title: '', options: layouts }]"
          :show-options="initialized && showOptions === 'layouts'"
          v-model="selectedLayouts"
          @open-options="showOptions = 'layouts'"
          @close-options="showOptions = ''"
          v-if="!['8200', '8300'].includes(brand) && fixedModel && layouts.length"/>
      <Filter
        identifier="service"
        :label="$t('filterBar.filters.serviceStations')"
        :option-groups="[{ title: '', options: serviceStations }]"
        :show-options="initialized && showOptions === 'serviceStations'"
        v-model="services"
        @open-options="showOptions = 'serviceStations'"
        @close-options="showOptions = ''"
        v-if="!['8200', '8300'].includes(brand) && serviceStations.length" />
      <Filter
        identifier="service"
        :label="$t('filterBar.filters.rentalStations')"
        :option-groups="[{ title: '', options: rentalStations }]"
        :show-options="initialized && showOptions === 'rentalStations'"
        v-model="services"
        @open-options="showOptions = 'rentalStations'"
        @close-options="showOptions = ''"
        v-if="!['8300'].includes(brand) && rentalStations.length" />
      <Filter
        identifier="service"
        :label="$t('filterBar.filters.campingPlaces')"
        :option-groups="[{ title: '', options: campingPlaces }]"
        :show-options="initialized && showOptions === 'campingPlaces'"
        v-model="services"
        @open-options="showOptions = 'campingPlaces'"
        @close-options="showOptions = ''"
        v-if="campingPlaces.length" />
      <div class="filter-bar__actions" v-if="mobile && filtersChanged">
        <div class="actions__action">
          <div class="btn -btn-alpha" @click="filtersChanged = showFilters = false">
            <span>{{ $t('filterBar.actions.apply') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Filter from '@/components/Filter'

export default {
  name: 'FilterBar',
  inject: ['mobile'],
  data () {
    return {
      showFilters: false,
      showOptions: '',
      filtersChanged: false
    }
  },
  components: {
    Filter
  },
  computed: {
    ...mapState({
      initialized: state => state.initialized,
      brand: state => state.brand,
      vehicleTypes: state => state.filter.available.vehicleTypes,
      models: state => state.filter.available.models,
      layouts: state => state.filter.available.layouts,
      serviceStations: state => state.filter.available.serviceStations,
      rentalStations: state => state.filter.available.rentalStations,
      campingPlaces: state => state.filter.available.campingPlaces,
      fixedModel: state => state.filter.model
    }),
    divisions: {
      get () {
        return this.$store.state.filter.divisions
      },
      set (value) {
        this.filtersChanged = true
        this.$store.commit('filter/setDivisions', value)
        this.filter()
      }
    },
    selectedModels: {
      get () {
        return this.$store.state.filter.models
      },
      set (value) {
        this.filtersChanged = true
        this.$store.commit('filter/setModels', value)
        this.filter()
      }
    },
    selectedLayouts: {
      get () {
        return this.$store.state.filter.layouts
      },
      set (value) {
        this.filtersChanged = true
        this.$store.commit('filter/setLayouts', value)
        this.filter()
      }
    },
    services: {
      get () {
        return this.$store.state.filter.services
      },
      set (value) {
        this.filtersChanged = true
        this.$store.commit('filter/setServices', value)
        this.filter()
      }
    }
  },
  methods: {
    ...mapActions([
      'filter'
    ])
  },
  created () {
    const self = this
    document.addEventListener('click', function (e) {
      if (self.$refs.container && self.$refs.link !== e.target && !self.$refs.link.contains(e.target) && self.$refs.container !== e.target && !self.$refs.container.contains(e.target)) {
        self.showFilters = false
      }
    })
  }
}
</script>
